import { Pipe, PipeTransform } from '@angular/core';
import { IncomeLevelCode } from '../security-deposit/applications/models/applications.model';

@Pipe({
  standalone: false,
  name: 'incomeLevel'
})
export class IncomeLevelPipe implements PipeTransform {
  private types: { [key: string]: string } = {};

  constructor() {
    this.types[IncomeLevelCode.from0To15] = '15000';
    this.types[IncomeLevelCode.from15To30] = '30000';
    this.types[IncomeLevelCode.from30To50] = '50000';
    this.types[IncomeLevelCode.from50To75] = '75000';
    this.types[IncomeLevelCode.from75To100] = '100000';
    this.types[IncomeLevelCode.over100] = '100000';
  }

  transform(value: IncomeLevelCode): string {
    return this.types[value] ?? 'Unknown';
  }
}
